import { render, staticRenderFns } from "./UnitSelectCalc.vue?vue&type=template&id=452166f0&scoped=true&"
import script from "./UnitSelectCalc.ts?vue&type=script&lang=ts&"
export * from "./UnitSelectCalc.ts?vue&type=script&lang=ts&"
import style0 from "./UnitSelectCalc.css?vue&type=style&index=0&id=452166f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452166f0",
  null
  
)

export default component.exports